import { useEffect } from "react";
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from "react-hook-form";
import { InputProps } from "../../../../../types/Form";
import { HookInputBaseProps } from "../../types";
import { FileInputFieldBase } from "./FileInputFieldBase";

export interface FileInputProps
  extends Omit<InputProps, "type">,
    HookInputBaseProps {
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  trigger: UseFormTrigger<any>;
  control: Control<any, any>;
  onFileRemove?: (fileIndex: number) => void;
}
export const FileInputField = (props: FileInputProps) => {
  const {
    name = "",
    required,
    validate,
    multiple,
    watch,
    control,
    setValue,
    trigger,
    id,
    onFileRemove,
    ...rest
  } = props;
  const idOrName = id || name;
  const files = watch(name) || [];
  const removeFile = (index: number) => {
    const filesCopy = [...files];
    filesCopy.splice(index, 1);
    setValue(name, [...filesCopy]);
    if (onFileRemove) {
      onFileRemove(index);
    }
  };

  useEffect(() => {
    if (files?.length) {
      trigger(name);
    }
  }, [files]);

  return (
    <>
      <Controller
        name={name}
        rules={{ required: required && "Required", validate }}
        control={control}
        render={({ field, fieldState: { error, isTouched } }) => {
          const totalFiles = ((files as File[]) || []).length;
          return (
            <>
              <FileInputFieldBase
                {...rest}
                {...field}
                id={idOrName}
                key={`${files?.length}`}
                value={
                  totalFiles > 1
                    ? `${totalFiles} file${totalFiles > 1 ? "s" : ""} selected`
                    : totalFiles === 1
                    ? files[0].name
                    : rest.placeholder
                }
                onChange={(e) => {
                  if (multiple) {
                    setValue(name, [
                      ...files,
                      ...Array.from<File>(e.target.files || []),
                    ]);
                  } else {
                    setValue(name, Array.from<File>(e.target.files || []));
                  }
                }}
                error={isTouched ? error?.message : ""}
                multiple={multiple}
                files={files}
                removeFile={removeFile}
              />
            </>
          );
        }}
      />
    </>
  );
};
